"use client";

import { useRouter } from "next/navigation";

import { LoginForm } from "@saas/account/feature/login-form/login-form";
import { useLoyaltyBrandContext } from "@saas/loyalty/feature/@context/loyalty-brand/loyalty-brand.context";
import { createLoyaltyUrl } from "@saas/loyalty/utils/create-loyalty-url/create-loyalty-url";

export const LoginClientPage = () => {
  const { brandSlug } = useLoyaltyBrandContext();
  const forgotPasswordHref = createLoyaltyUrl({
    brandSlug,
    pathname: "/forgot-password",
  });

  const router = useRouter();

  const handleSuccess = () => {
    router.push(createLoyaltyUrl({ brandSlug }));
  };

  return (
    <LoginForm
      onSuccess={handleSuccess}
      forgotPasswordHref={forgotPasswordHref}
    />
  );
};
